import { openCloseToast, sendEmailApp } from '../../../../Global/actions';
import { deleteSolicitudApi, getSolicitudesApi } from '../../../../../services/AprobarSolicitudesApi';

import { createUserAdWithRolesApiJwt, validateUserExist } from '../../../../../services/registroApi';
import { overrideRolesForUser } from '../../../../../services/userRolesApi';
import { deleteSolicitudADApi } from '../../../../../services/solicitudesApi';
import apiConfig from '../../../../../config/api'
// deleteSolicitudADApi

export const loading = (isLoading) => ({
    type: 'LOADING_APROBAR_SOLUCITUDES',
    isLoading,
});

export const openCloseSelectRoles = (isOpen) => ({
    type: 'OPEN_CLOSE_SELECT_ROLES',
    isOpen,
});

export const setSolicitudes = (solicitudes) => ({
    type: 'SET_SOLICITUDES',
    solicitudes,
});


export const resetStateSolicitudes = () => ({
    type: 'SET_RESET_STATE',
});


export const doGetSolicitudes = (rutEmpresa) => async (dispatch) => {
    dispatch(loading(true));
    try {
        const response = await getSolicitudesApi(rutEmpresa);
        if (response.status === 200) {
            const result = await response.json();
            dispatch(setSolicitudes(result.Data));
        } else {
            dispatch(openCloseToast({
                isToastOpen: true,
                msgToast: 'Error al obtener las solicitudes pendientes',
                typeStyle: 'error',
                displayTime: 5000
            }));
        }
    } catch {
        dispatch(openCloseToast({
            isToastOpen: true,
            msgToast: 'Error de conexión, intente mas tarde',
            typeStyle: 'error',
            displayTime: 5000
        }));
    }
    dispatch(loading(false));
};

export const doAcceptSolicitud = (userRegister) => async (dispatch) => {
    dispatch(loading(true));

    const existResponse = await validateUserExist(userRegister.Rut);
    const userAD = await existResponse.json();

    const createAD = {
        UserType: 'emailAddress',
        Email: userRegister.Email,
        Password: userRegister.Password,
        FirstName: userRegister.FirstName,
        LastName: userRegister.LastName,
        Rut: userRegister.Rut,
        RelationTypeCode: userRegister.RelationTypeCode,
        Mobile: userRegister.Phone,
        CompanyRut: userRegister.CompanyRut,
        CompanyName: userRegister.CompanyName,
        IdRoles: [],
        IsAchsWorker: (userRegister.CompanyRut === apiConfig.rutAchs)
    };

    if (Array.isArray(userRegister.IdRol)) {
        const dependentWorker = userRegister.IdRol.find(r => r.Id === +process.env.REACT_APP_DEPENDENT_WORKER_ROL)
        if(createAD.IsAchsWorker && dependentWorker)
            createAD.IdRoles.push(+apiConfig.idTrabajadorACHS)

        userRegister.IdRol.forEach((rol) => {
            if (rol.Id !== undefined)
                createAD.IdRoles.push(rol.Id);
        });
    }
    // else if (userRegister.codeRol) {
    //     const rolRequest = await getRolIdByCode(userRegister.codeRol);
    //     if (rolRequest.status === 200) {
    //         const rolResult = await rolRequest.json();
    //         if (rolResult.Success) {
    //             createAD.IdRoles = [rolResult.Rol.Id];
    //         }
    //     }
    //     if (createAD.CompanyRut === constants.achsRut) {
    //         const rolTrabajadorAchs = await getRolIdByCode(constants.codeRolTrabajadorAchs);
    //         if (rolTrabajadorAchs.status === 200) {
    //             const achsResult = await rolTrabajadorAchs.json();
    //             if (achsResult.Success) {
    //                 if (Array.isArray(createAD.IdRoles)) {
    //                     createAD.IdRoles.push(achsResult.Rol.Id);
    //                 } else {
    //                     createAD.IdRoles = [achsResult.Rol.Id];
    //                 }
    //             }
    //         }
    //     }
    // }

    if (userAD.ExistsBD) {
        // Usuario ya existe en el AD, por lo que se le assignan los roles nuevos, se cambia a override
        // const createResponse = await createRolesForUserAndCompany(createAD.Rut, createAD.CompanyRut, createAD.RelationType, createAD.IdRoles);
        const createResponse = await overrideRolesForUser(createAD.Rut, createAD.RelationTypeCode, createAD.CompanyRut, createAD.IdRoles, false);
        const createResult = await createResponse.json();
        if (createResponse.status === 200) {
            if (createResult.Success) {
                const deleteResponse = await deleteSolicitudADApi(createAD.Rut, userRegister.Id);
                // si se quiere dejar la solicitud para pruebas comentar la linea de arriba y descomentar la de abajo
                // const deleteResponse = {status: 200}
                if (deleteResponse.status === 200) {
                    const parametersMail = {};
                    parametersMail.userInfo = {
                        RutEmpresa: createAD.CompanyRut,
                        NombreEmpresa: createAD.CompanyName,
                        Email: createAD.Email,
                        FirstName: createAD.FirstName,
                        LastName: createAD.LastName,
                    };
                    parametersMail.templateMail = 'solicitudAprobada';
                    await dispatch(sendEmailApp(parametersMail));
                    dispatch(doGetSolicitudes(userRegister.CompanyRut));
                    dispatch(openCloseToast({
                        isToastOpen: true,
                        msgToast: 'Se ha actualizado el permiso del usuario con éxito.',
                        typeStyle: 'success',
                        displayTime: 5000
                    }));
                }
            }
        } else {
            dispatch(openCloseToast({
                isToastOpen: true,
                msgToast: `${createResult.Message}. Rol ya existente.`,
                typeStyle: 'warning',
                displayTime: 5000
            }));
        }
    } else {
        // Usuario no existe en el AD, por lo que se crea con sus roles
        const response = await createUserAdWithRolesApiJwt(createAD);
        const result = await response.json();
        if (response.status === 200) {
            if (result.Success) {
                // ENVIO DE CORREO DE ACTIVACION
                // const hostname = window && window.location && window.location.hostname;
                // const uriMail = hostname === 'localhost' ? 'http://localhost:3001' : `https://${hostname}`;
                // dispatch(doSendMailUser(createAD, result.ActivationToken));

                const responseDelete = await deleteSolicitudApi(createAD.Rut, userRegister.Id);
                if (responseDelete.status === 200) {
                    dispatch(doGetSolicitudes(userRegister.CompanyRut));
                    dispatch(openCloseToast({
                        isToastOpen: true,
                        msgToast: 'Solicitud aceptada con éxito',
                        typeStyle: 'success',
                        displayTime: 5000
                    }));
                }
            } else {
                dispatch(openCloseToast({
                    isToastOpen: true,
                    msgToast: 'Error en la creacion del usuario: Contáctanos a ejecutivoachs@achs.cl',
                    typeStyle: 'error',
                    displayTime: 5000
                }));
            }
        }
    }

    dispatch(loading(false));
};

export const doRejectSolicitud = (userData, fromUserAD) => async (dispatch) => {
    dispatch(loading(true));

    let response;

    if (fromUserAD) {
        response = await deleteSolicitudADApi(userData.Rut, userData.Id);
    } else {
        response = await deleteSolicitudApi(userData.Rut, userData.Id);
    }

    if (response.status === 200) {
        dispatch(doGetSolicitudes(userData.CompanyRut));
        const parametersMail =
            {
                userInfo: {
                    RutEmpresa: userData.CompanyRut,
                    NombreEmpresa: userData.CompanyName,
                    Email: userData.Email,
                    FirstName: userData.FirstName,
                    LastName: userData.LastName,
                },
            };
        parametersMail.templateMail = 'solicitudRechazada';
        await dispatch(sendEmailApp(parametersMail, false));
        dispatch(openCloseToast({
            isToastOpen: true,
            msgToast: 'Su rechazo al cambio de rol ha sido procesado con éxito',
            typeStyle: 'success',
            displayTime: 5000
        }));
        // dispatch(sendMailRejection(userData));
    } else {
        dispatch(doGetSolicitudes(userData.CompanyRut));
        dispatch(openCloseToast({
            isToastOpen: true,
            msgToast: 'Error al rechazar el usuario',
            typeStyle: 'error',
            displayTime: 5000
        }));
    }

    dispatch(loading(false));
};

